import React, { useState, useEffect } from "react";

import AddList from "./AddList";
import Summary from "./Summary";
import {
  getInsuranceTypes,
  getUserInsurance,
} from "../../../../../services/yourAssets/InsuranceServices";

import { useDispatch, useSelector } from "react-redux";
import { nextCard } from "../../../../../redux/slices/CardSlices";
import { useParams } from "react-router-dom";
import { assetStepsNames } from "../../../../../constants/constants";

const Insurance = ({ next, updates }) => {
  const { id } = useParams();
  const [selectedProperties, setSelectedProperties] = useState([]);
  const [summaryValues, setSummaryValues] = useState([]);
  const [userValues, setUserValues] = useState([]);
  const [updationFlag, setUpdationFlag] = useState(false);
  const [continueButton, setContinueButton] = useState(true);
  const [updatedIds, setUpdatedIds] = useState([]);
  const auditTrailIds =
    updates
      .filter(
        (item) =>
          item.objectName === assetStepsNames[3] ||
          item?.objectName?.toLowerCase() ===
            "sub" + assetStepsNames[3]?.toLowerCase()
      )
      .map((item) => item?.auditTrailId) || [];

  const [updatesList, setUpdatesList] = useState([]);
  const dispatch = useDispatch();
  const currentCard = useSelector((state) => state.currentCard.currentCard);
  const getInsuranceTypesList = async () => {
    await getInsuranceTypes(id);
  };
  const getUserInsuranceList = async () => {
    let apiResult = await getUserInsurance(id);
    if (apiResult?.success) {
      let data = [];
      apiResult.payLoad.forEach((el) => {
        let owner = el.Insurance;
        let obj = {
          userInsuranceId: owner.insuranceId,
          name: el.insuranceCategoryName,
          id: owner.insuranceCategoryId,
          type: el.insuranceParentCategoryId === 1 ? "personal" : "assets",
          translationKey: el?.translationKey || "",
          owner: {
            name: owner.insuranceHolder,
            insuredPerson: owner.insuredPerson,
            beneficiary: owner.beneficiaries,
            value: owner.buyBackValue,
            deathBenifit: owner.deathBenefit,
            documentName: owner.documentName,
            documentId: owner.documentId,
            id: owner.insuranceId,
            subOwners: owner.subInsurances.map((item) => {
              return {
                name: item.insuranceHolder,
                insuredPerson: item.insuredPerson,
                beneficiary: item.beneficiaries,
                value: item.buyBackValue,
                deathBenifit: item.deathBenefit,
                documentName: item.documentName,
                documentId: item.documentId,
                userInsuranceDetailId: item.insuranceId,
                subInsuranceDetail: item.subInsuranceId,
              };
            }),
          },
        };
        data.push(obj);
        setContinueButton(false);
      });

      setUserValues(data);
      if (data.length > 0) {
        setUpdationFlag(true);
        if (currentCard == 1) {
          dispatch(nextCard());
        }
      }
    }
  };
  const handlePreSetApiData = () => {
    const updtedSelectedProperties = userValues.map((el) => {
      return {
        id: el.id,
        type: el.type,
        name: el.name,
      };
    });
    setSelectedProperties(updtedSelectedProperties);
  };

  const handlePreSetApiSummaryValues = () => {
    let updatedSummaryValues = [];
    selectedProperties.forEach((el) => {
      let matchedObj = userValues.filter((item) => item.id === el.id);
      if (matchedObj.length > 0) {
        updatedSummaryValues.push(matchedObj[0]);
      } else {
        updatedSummaryValues.push(el);
      }
    });

    setSummaryValues([...updatedSummaryValues]);
  };
  useEffect(() => {
    getInsuranceTypesList();
    getUserInsuranceList();
    setUpdatedIds(
      updates
        .filter((item) => item.objectName === assetStepsNames[3])
        .map((item) => item?.keyValues?.ObjectId)
    );

    setUpdatesList(
      updates
        .filter((item) => item.objectName === assetStepsNames[3])
        .map((item) => item)
    );
  }, []);

  useEffect(() => {
    handlePreSetApiData();
  }, [userValues]);
  useEffect(() => {
    handlePreSetApiSummaryValues();
    let idsArray = [];
    for (let i = 0; i < selectedProperties.length; i++) {
      const element = selectedProperties[i];
      idsArray.push(element.id);
    }
    if (
      idsArray.includes("b63a13ec-5fa8-421d-b106-0088626399e6") ||
      idsArray.includes("f901067d-da0c-45f9-b680-6a6e68874ea7") ||
      idsArray.includes("5e4c1ffa-f9cb-45ce-86ad-f3a879e5118c")
    ) {
      setContinueButton(true);
    } else {
      setContinueButton(false);
    }
  }, [selectedProperties]);
  const handleSetProperties = (obj) => {
    const value = selectedProperties.find((item) => {
      if (item.id === obj.id) return true;
      return false;
    });
    if (value !== undefined) {
      setSelectedProperties((pre) =>
        pre.filter((item) => item.id !== value.id)
      );
    } else {
      setSelectedProperties((pre) => [...pre, obj]);
    }
  };

  const handleSetSummaryValues = (arr) => {
    setSummaryValues(arr);
  };

  const handleResetSummaryValues = () => {
    if (summaryValues.length === 0) {
      setSummaryValues([...selectedProperties]);
    }
  };

  const handleDeleteSummaryRow = (id) => {
    setSummaryValues((pre) => [
      ...pre.map((item) => {
        if (item.id === id) {
          return selectedProperties.find((ele) => ele.id === id);
        }
        return item;
      }),
    ]);
  };

  const renderTab = () => {
    if (currentCard === 1) {
      return (
        <AddList
          selectedProperties={selectedProperties}
          handleSetProperties={handleSetProperties}
        />
      );
    } else if (currentCard === 2) {
      return (
        <Summary
          next={next}
          selectedProperties={selectedProperties}
          summaryValues={summaryValues}
          handleSetSummaryValues={handleSetSummaryValues}
          handleResetSummaryValues={handleResetSummaryValues}
          handleDeleteSummaryRow={handleDeleteSummaryRow}
          updationFlag={updationFlag}
          disableContinueButton={continueButton}
          updatedIds={updatedIds}
          auditTrailIds={auditTrailIds}
          updatesList={updatesList}
        />
      );
    }
  };
  return <>{renderTab()}</>;
};

export default Insurance;
